import { Input } from '@components/Input';
import { useTranslation } from '@hooks';
import { getSurveyTextError } from '@helpers/surveyLanguages';

const LocalizedFieldInput = ({ field, value, onChange, onBlur, touched = true, disabled, sx }) => {
    const { t } = useTranslation();
    const error = touched ? getSurveyTextError(value, field) : null;

    return (
        <Input
            inputProps={{ name: field.name, value: value || '', onChange, onBlur }}
            label={t(field.label, field.labelOptions)}
            required={!field.optional}
            fullWidth
            multiline={field.multiline}
            minRows={field.multiline ? 3 : undefined}
            disabled={disabled}
            error={!!error}
            helperText={error ? t(error, { count: field.maxLength }) : ''}
            sx={sx}
        />
    );
};

export default LocalizedFieldInput;
